import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortBy',
    standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], by: string, ...args: unknown[]): any[] {
    if (!value.length && !value[0][by]){
      return value
    }
    return value.sort((a:any ,b:any): number => {
      if(a[by]<b[by]){
        return -1;
      }
      if(a[by]>b[by]){
        return 1;
      }
      return 0;
    })
  }

}
